module.exports = __webpack_public_path__ + "img/item_26.02f4b830.png";